import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import MoneyRenderer from "../../utils/MoneyRenderer";
import errorToast from "../../../components/toast/ErrorToast";

export class OrdersHistoryFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._orders = [];
        this._loaded = false

        makeObservable(this, {
            _orders: observable,
            orders: computed,
            _loaded: observable,
        })
    }

    async load() {
        await this._getOrders()
        this.finishLoading()
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get orders() {
        return this._orders;
    }

    set orders(value) {
        this._orders = value;
    }

    repeatOrder() {
        console.log('REPEAT ORDER')
    }

    orderIsFromMarketplace(order) {
        return (order.number.split("-")[0] === '01')
    }

    async editOrder(order) {
        if (order.state === 'CERRADO') {
            await this.returnOrderToInitial(order)
        }
        this._application.setOrder(order)
    }

    async returnOrderToInitial(order) {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
            },
            handlesError: async (response) => {
                if (response.orderWasDeleted?.()) {
                    await this._application.session().logOutAndRemoveOrder()
                    return errorToast("El pedido fue eliminado. Por favor, ingrese nuevamente y acceda a 'Mis Pedidos' para ver sus pedidos activos.")
                }
            }
        });
        this._application.apiClient().returnOrderToInitial(order.number, responseHandler);
    }

    articleAmountWithLabel(article){
        return `${article.amount} ${article.amount > 1 ? 'cajas' : 'caja'}`;
    }

    totalFor(order) {
        return MoneyRenderer(order.totalPrice)
    }

    orderOrInvoiceNumber(order) {
        if (order.state === 'FACTURADO'){
            return order.invoiceNumber
        }
        return order.number
    }

    isInRevisionOrRejected(order){
        return order.state === 'RECHAZADO' || order.state === 'EN REVISIÓN'
    }

    _getOrders() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._orders = response.orders();
            },
            handlesError: (response) => {
                console.log('No se pudieron obtener los pedidos')
            }
        });
        return this._application.apiClient().getOrders(responseHandler, this._application.getCustomer())
    }
}